import React, { ReactNode, useRef } from "react";
import './dlgs.css';
import './popup.css';
import { createPortal } from "react-dom";

const portal = document.createElement('div');
portal.id = 'popup';
document.body.appendChild(portal);


type LoadingSpinnerProps = { belowLoader?: ReactNode };

export default function LoadingSpinner({ belowLoader }: LoadingSpinnerProps = {}) {
    const fillerRef = useRef<HTMLDivElement>(null);

    return createPortal(<div className='filler filler-spinner' ref={fillerRef}>
        <div className='loader-popup'>
            <div className="loader" />
            {!!belowLoader && <div className="loader-below-wrap">{belowLoader}</div>}
        </div>
    </div>, portal)
}
